import { ALLOCATIONS } from '../allocations/allocations';
import { EXPERIMENTS } from '../experiments/experiments';

export type MiraEntryPointsVariant = 'chat' | 'miniFlow' | 'orbit';

const MIRA_ENTRY_POINTS_VARIANTS: Record<string, MiraEntryPointsVariant> = {
    [ALLOCATIONS.TEST_B]: 'chat',
    [ALLOCATIONS.TEST_C]: 'miniFlow',
    [ALLOCATIONS.TEST_D]: 'orbit',
};

/**
 * Mira entry points experiment: group 1 (control) or not allocated → null (current Mira entry point).
 * Groups 2-4 render the mira_entry_points placement's chat / miniFlow / orbit variant.
 */
export const getMiraEntryPointsVariant = (
    abTests: Record<string, number | string> = {}
): MiraEntryPointsVariant | null =>
    MIRA_ENTRY_POINTS_VARIANTS[String(abTests[EXPERIMENTS.MIRA_ENTRY_POINTS_V1])] ?? null;
